export {
  isOnline,
  getConnectivityStatus,
  subscribeConnectivity,
  type ConnectivityStatus,
} from '../../shared/connectivity/connectivityInfra';
